<!-- 左侧导航组件 -->
<!-- 使用说明：<side-bar></side-bar> -->
<template>
    <div id="sidebar-wrap" :class="{ collapsed: toggSiderBar }">
        <!-- <h3 class="logo">
          <img src="@/assets/images/logo.png"/>
          <span class="rythm twist1">镜面系统-可视化综合分析工作台</span>
        </h3> -->
        <el-menu style="width:175px;" background-color="#324157" text-color="#ddd" :default-active="$route.path" :unique-opened="isUnique" :router="isRouter" mode="vertical" :collapse="toggSiderBar">
            <template v-for="item in navData">
                <!-- <el-submenu v-if="item.children.length !== 0" :index="item.id" :key="item.router">
                    <template slot="title">
                        <i :class="item.icon"></i>
                        <span slot="title">{{item.name}}</span>
                    </template>
                </el-submenu> -->

                <el-menu-item :index="item.router" :key="item.router">
                    <i :class="item.icon"></i>
                    <span slot="title" v-if="item.name == '项目管理'">{{item.name}}
                      <el-badge :value="solveValue" class="item" type="success" v-if="solveValue == 0"
                        style="display:none">
                      </el-badge>
                      <el-badge :value="solveValue" class="item" type="success" v-else>
                      </el-badge>
                    </span>
                    <span slot="title" v-else>{{item.name}}</span>
                    <!-- <span slot="title">{{item.name}}</span> -->
                </el-menu-item>
            </template>
            <!-- <el-submenu index="1">
                    <template slot="title">
                        <i class="el-icon-time"></i>
                        <span slot="title">项目管理</span>
                    </template>
                    <el-menu-item index="/project-info">
                        <i class="el-icon-menu"></i>
                        <span slot="title">项目信息</span>
                    </el-menu-item>
                    <el-menu-item index="/project-path">
                        <i class="el-icon-share"></i>
                        <span slot="title">项目路径</span>
                    </el-menu-item>
                    <el-menu-item index="/enroll-list">
                        <i class="el-icon-document"></i>
                        <span slot="title">报名列表</span>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item index="/operation-log">
                    <i class="el-icon-date"></i>
                    <span slot="title">操作日志</span>
                </el-menu-item> -->
        </el-menu>
    </div>
</template>
<script>
import {navdataa} from "../assets/js/navData.js";
let common = {
    state: {
        isCollapse: false,
        chartTheme: ["#2ec7c9", "#b6a2de", "#5ab1ef", "#ffb980", "#d87a80", "#8d98b3", "#e5cf0d", "#97b552", "#95706d", "#dc69aa", "#07a2a4", "#9a7fd1", "#588dd5", "#f5994e", "#c05050", "#59678c", "#c9ab00", "#7eb00a", "#6f5553", "#c14089"],
    },
    mutations: {
        toggleSiderBar(state) {
            state.isCollapse = !state.isCollapse
        }
    }
}
export default {
  name: "sidebar",
  data() {
    return {
      isMusicOn: false,
      isUnique: true,
      isRouter: true,
      navData:[],
      id: this.$store.getters.getId,
      solveValue:'',
    };
  },
  computed: {
    toggSiderBar() {
      return common.isCollapse;
    }
    // langType() {
    //   return this.$i18n.locale;
    // }
  },
  created() {
    this.navData = this.$store.getters.getPermission;
  },
  mounted(){
      // this.navData = navdataa.list;
      this.getProjectList();
  },
  methods: {
    //获取项目管理未解决数量
    getProjectList(eva){
        this.axios({
            method:'post',
            url:window.API_HOST+'/problem/selectAllProjects.do',
        }).then((res)=>{
          // console.log(res.data);
          if(res.data.status == 200){
            let t = res.data.data.length;
            this.solveValue = res.data.data[t-1].totalsolve;
            // console.log(this.solveValue)
          }
        })
      },
  }
};
</script>
<style scoped lang="scss">
#sidebar-wrap {
  width: 175px;
  height: 100%;
  position: relative;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 4;

  /* 图标动画 */
  .imgWrap {
    text-align: center;
    position: absolute;
    bottom: 30px;
    width: 100%;
    .gif {
      width: 60px;
      height: 60px;
      border-radius: 30px;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .logo {
    color: #fff;
    width:335px;
    text-align: center;
    background: #4D74FF;
    padding:0;
    margin: 0;
    height:60px;
    line-height:60px;
    display: flex;
    img{
        margin: 12px 6px 0 20px;
        display: inline-block;
        width: 37px;
        height: 37px;
    }
  }
}

// 动态改变左侧导航包裹层宽度
#sidebar-wrap.collapsed {
  width: 64px;
}
.el-menu {
  height: 100%;
  width: 175px;
}

// 美化左侧导航的留白
.el-submenu .el-menu-item {
  padding: 0 20px;
  min-width: 160px;
  padding-left: 20px !important;
}

// 改变元素属性，要不动画效果不管用，是不是很厉害啊？哈哈哈
.rythm.twist1 {
  display: block;
}
/deep/ .el-badge__content {
    background-color: red;
    font-weight: 600;
  }
  /deep/ .el-badge__content.is-fixed {
    right: 0px;
  }
  /deep/ .el-badge {
    position: relative;
    display: inline-block;
    top: -3px;
}
</style>
